import * as React from 'react'
import Dialog from '@material-ui/core/Dialog'
import { useAtom } from 'jotai'
import styled from 'styled-components'
import { X } from '@geist-ui/react-icons'
import { mobileConnectAtom } from '../../atoms/Wallet'
import { useWalletModal } from '@solana/wallet-adapter-react-ui'
import { useMediaQuery } from '@material-ui/core'

// ========================== React component ==================================

const MobileConnectDialog = (): JSX.Element => {
  //   const [, setToast] = useToasts()
  const isMobile = useMediaQuery('(max-width: 43em)')
  const [open, setOpen] = useAtom(mobileConnectAtom)
  const { visible, setVisible } = useWalletModal()

  function getCurrentLink(): string {
    const currentURL = new URL(window.location.href)
    currentURL.searchParams.delete

    return currentURL.href
  }

  const connectPhantom = async (): Promise<void> => {
    const window: any = globalThis.window
    if (isMobile) {
      setOpen(false)
      window.open(
        `https://phantom.app/ul/browse/${encodeURIComponent(
          getCurrentLink()
        )}?ref=${encodeURIComponent(getCurrentLink())}`
      )
      return
    } else if ('phantom' in window) {
      const provider = window.phantom?.solana

      if (provider?.isPhantom) {
        setVisible(true)
        return
      }
    }
    setOpen(false)
    window.open('https://phantom.app/', '_blank')
  }

  const connectCrossmint = async (): Promise<void> => {
    setOpen(false)
    setVisible(true)
  }

  React.useEffect(() => {
    if (!visible && open) {
      setOpen(false)
    }
  }, [visible])

  return (
    <Dialog
      onClose={() => {
        console.log('Closed')
      }}
      aria-labelledby="profile-verification-dialog"
      open={open}
      PaperProps={{
        style: {
          backgroundColor: '#101010',
          borderRadius: 15,
          minWidth: isMobile ? '90vw' : '500px',
          width: isMobile ? '90vw' : '50vh',
          minHeight: '450px',
          height: '40vh',
        },
      }}
      BackdropProps={{
        style: {
          backdropFilter: 'blur(20px)',
        },
      }}
    >
      <OuterDiv>
        <CloseButton color="white" size={'30px'} onClick={() => setOpen(false)} />
        <Title>Sign in to Glass with a Solana wallet</Title>
        <Column>
          <Subtitle>{`Don't have a Solana wallet yet?`}</Subtitle>
          <PhantomRow onClick={() => connectCrossmint()}>
            <PhantomLogo>
              <PhantomIcon src="/icons/crossmint.png" />
              Crossmint
            </PhantomLogo>
            <Recommended>Recommended</Recommended>
          </PhantomRow>
        </Column>
        <Column>
          <Subtitle>{`Already have one?`}</Subtitle>
          <PhantomRow onClick={() => connectPhantom()}>
            <PhantomLogo>
              <PhantomIcon src="/icons/phantom-icon-purple.svg" />
              Phantom
            </PhantomLogo>
            <Recommended>Recommended</Recommended>
          </PhantomRow>
        </Column>
        <Other
          onClick={() => {
            setVisible(true)
          }}
        >
          Other Options
        </Other>
      </OuterDiv>
    </Dialog>
  )
}

export default MobileConnectDialog

// ========================== Styled components ================================

const OuterDiv = styled.div`
  width: calc(100% - 100px);
  height: 85%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 15%;
  margin-right: 50px;
  margin-left: 50px;
`

const Title = styled.div`
  color: white;
  font-size: 28px;
  font-weight: 600;
  text-align: center;
  padding: 25px 0;
  padding-bottom: 0;

  @media (max-width: 43em) {
    font-size: 24px;
  }
`

const Subtitle = styled.div`
  color: white;
  font-size: 18px;
  font-weight: 400;
  text-align: left;
  width: calc(100% + 40px);
`

const CloseButton = styled(X)`
  right: 4%;
  top: 4%;
  position: absolute;
  cursor: pointer;
`

const Other = styled.div`
  right: 4%;
  bottom: 4%;
  position: absolute;
  color: #aaa;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
`

const PhantomRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  background-color: #323232;
  color: white;
  font-size: 18px;
  font-weight: 600;
  border-radius: 15px;
  cursor: pointer;
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 20px;
`

const PhantomLogo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const PhantomIcon = styled.img`
  object-fit: contain;
  height: 25px;
  margin-right: 10px;
`

const Recommended = styled.div`
  color: #aaa;
  font-size: 14px;
  font-weight: 600;
`
